import { PowerBIEmbed } from 'powerbi-client-react'
import { models } from 'powerbi-client'
import { Form, Row, Select, Button } from 'antd'
import React, { useState, useContext, useEffect, useRef } from 'react'
import 'styleLess/signature/dataanalytics.scss'
import { getCookie } from 'helper/cookie'
import { GET_POWER_BI_LIST, GET_POWER_BI_BY_ID } from 'api/PowerBI/analytics'
import { CounterContext } from 'redux/Golbalvalues'
import {
  InboxOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  FullscreenOutlined,
} from '@ant-design/icons'
import { Helmet } from 'react-helmet'
// import analyticsEmpty from '../../icons/sidebar/analytics-cloud.svg'
const AnalyticsComponent = () => {
  const token = getCookie('access_token_admin')
  const userID = getCookie('userID')
  const [form1] = Form.useForm()
  const { Option } = Select
  const { setPathActive } = useContext(CounterContext)
  const [listBI, setListBI] = useState([])
  const [isloading, setIsLoading] = useState(false)
  const [reportid, setReportID] = useState('')
  const [embedurl, setEmbedUrl] = useState('')
  const [accessToken, setAccessToken] = useState('')
  const [report, setReport] = useState(null)

  const getListPowerBI = async () => {
    await GET_POWER_BI_LIST({
      token: token,
      user_id: userID,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (status === 200) {
          const getDataALLBIList = data?.report
          const getFirstIndexID = data?.report[0].id
          await getPowerBIbyID(getFirstIndexID)
          setListBI(getDataALLBIList)
          form1.setFieldsValue({
            analytics_id: data?.report[0].id,
          })
        }
      })
      .catch((error) => {
        setListBI([])
        console.error(error)
      })
    setIsLoading(true)
  }
  const getPowerBIbyID = async (idReport) => {
    await GET_POWER_BI_BY_ID({
      token: token,
      user_id: userID,
      id: idReport,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (status === 200) {
          // console.log(data)

          const getReportID = data?.report[0].report_id
          const getReportURL = data?.report[0].report_url
          const getToken = data?.access_token

          // console.log('ReportID:', getReportID, 'URL:', getReportURL, 'TOKen:', getToken)
          setReportID(getReportID)
          setEmbedUrl(getReportURL)
          setAccessToken(getToken)
        }
      })
      .catch((error) => {
        setListBI([])
        console.error(error)
      })
  }
  const onChangeSelected = async (idBI) => {
    const BIListFiltering = listBI.find((item) => item.id === idBI)
    await getPowerBIbyID(BIListFiltering.id)
    form1.setFieldsValue({
      analytics_id: BIListFiltering.id,
    })
  }
  useEffect(() => {
    if (token) {
      setPathActive('/data-analytics')
      getListPowerBI()
    }
  }, [token])
  useEffect(() => {
    if (report == null) return
    report.refresh()
  }, [report, accessToken])

  const zoomInReport = async () => {
    let currentZoom = await report.getZoom()
    currentZoom = currentZoom + 0.2
    await report.setZoom(currentZoom)
  }

  const zoomOutReport = async () => {
    let currentZoom = await report.getZoom()
    currentZoom = currentZoom - 0.2
    await report.setZoom(currentZoom)
  }

  const fullScreenReport = async () => {
    await report.fullscreen()
  }

  return (
    <div className='analytics-container'>
      <Helmet>
        <title>AXONS PROJECT | Data Analytics</title>
      </Helmet>
      <Row className='analytics-in-header'>
        <h1 className='no-breadcrumb'>Data analytics</h1>
        <Form form={form1}>
          <Form.Item name='analytics_id' noStyle>
            <Select
              className='Select Select-Custom'
              placeholder='Analytics Select'
              style={{ minWidth: '240px', borderRadius: '4px' }}
              size='large'
              showSearch
              onChange={onChangeSelected}
              defaultActiveFirstOption={true}
              optionFilterProp='children'
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {listBI?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Row>
      {listBI.length !== 0 ? (
        <>
          <div id='BIcontainer' className='analytics-in-body'>
            <PowerBIEmbed
              key={accessToken}
              embedConfig={{
                type: 'report', // Supported types: report, dashboard, tile, visual and qna
                id: reportid,
                embedUrl: embedurl,
                accessToken: accessToken,
                tokenType: models.TokenType.Embed,
                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                  },
                },
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    function () {
                      // console.log('Report loaded')
                    },
                  ],
                  [
                    'rendered',
                    function () {
                      // console.log('Report rendered')
                    },
                  ],
                  [
                    'error',
                    function (event) {
                      // console.log(event.detail)
                      // reload()
                    },
                  ],
                ])
              }
              cssClassName={'report-style-class'}
              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport
                setReport(embeddedReport)
              }}
            />
          </div>
          <div className='analytics-in-option'>
            <Button className='btn-analytics-event' onClick={zoomInReport}>
              <ZoomInOutlined className='ico-analytics-event' /> ZOOM IN
            </Button>
            <Button className='btn-analytics-event' onClick={zoomOutReport}>
              <ZoomOutOutlined className='ico-analytics-event' /> ZOOM OUT
            </Button>
            <Button className='btn-analytics-event' onClick={fullScreenReport}>
              <FullscreenOutlined className='ico-analytics-event' /> FULL SCREEN
            </Button>
          </div>
        </>
      ) : isloading === true ? (
        <div className='analytics-in-empty-state'>
          {/* <img src={analyticsEmpty} className="analytics-icon" /> */}
          <InboxOutlined className='inboxoutlined' />
          <h1>No Data analytics </h1>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
export default AnalyticsComponent
